import { DealStats } from 'app/console-api';
import { BodyText, FlexColumn, FlexRow } from '@make-software/cspr-design';
import { calculateProgress } from 'app/components/management/apps/deals/common/progress-bar-calculator';
import React from 'react';
import styled from 'styled-components';

const EmptyStyledStatisticsRow = styled(FlexRow)(({ theme }) =>
  theme.withMedia({
    width: '100%',
    height: '12px',
    backgroundColor: '#F5F5F7',
    marginBottom: '12px',
    borderRadius: '2px'
  })
);

const StyledStatisticsRow = styled(FlexRow)<{ sent: number; received: number }>(
  ({ theme, sent, received }) =>
    theme.withMedia({
      width: '100%',
      height: '12px',
      marginBottom: '12px',
      borderRadius: '2px',
      background: `linear-gradient(to right, #F1BF0B 0%, #F1BF0B ${sent}%, #8B5BF1 ${sent}%, #8B5BF1 ${received}%, #8B5BF1 ${100}%)`
    })
);

export interface ProgressBarProps {
  stats: DealStats;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ stats }) => {
  return (
    <FlexColumn>
      <FlexRow>
        {stats.claimedOut === 0 && stats.claimedIn === 0 ? (
          <EmptyStyledStatisticsRow />
        ) : (
          <StyledStatisticsRow
            sent={calculateProgress(stats.claimedIn || 0, stats.claimedOut || 0).sent}
            received={calculateProgress(stats.claimedIn || 0, stats.claimedOut || 0).received}
          />
        )}
      </FlexRow>
      {!(stats.claimedOut === 0 && stats.claimedIn === 0) && (
        <>
          <FlexRow justify={'space-between'} align={'center'}>
            {stats.claimedOut > 0 && (
              <BodyText size={2} scale={'sm'}>
                {stats.claimedOut}
              </BodyText>
            )}
            {stats.claimedIn > 0 && (
              <BodyText size={2} scale={'sm'}>
                {stats.claimedIn}
              </BodyText>
            )}
          </FlexRow>
          <FlexRow justify={'space-between'} align={'center'} gap={100}>
            {stats.claimedOut > 0 && (
              <BodyText size={2} scale={'xs'} variation={'darkGray'}>
                sent
              </BodyText>
            )}
            {stats.claimedIn > 0 && (
              <BodyText size={2} scale={'xs'} variation={'darkGray'}>
                received
              </BodyText>
            )}
          </FlexRow>
        </>
      )}
    </FlexColumn>
  );
};
